import React, { useEffect, useState } from "react";
import ResponsiveDataTable from "../DataTable";
import { formatDateColumn } from "../../contents/VariaveisGlobais";
import { handleValorTotal, handlePrecoUnitario } from "../GridCell/Preco";
import { Col, Row } from "react-bootstrap";
import { CelBreak, CelBreak25 } from "../GridCell/styles";

const UltimasCompras = (DisparaBootBox, FechaBox, dataCompras) => {
    const columns = [
        { Header: 'Filial',         accessor: 'C7_FILIAL' },
        { Header: 'Pedido',         accessor: 'C7_NUM' },
        { Header: 'Emissão',        accessor: 'C7_EMISSAO', Cell: formatDateColumn },
        { Header: 'Fornecedor',     accessor: "FORNECE", Cell: (item) => {
            const { FORNECE, A2_NOME, C7_CC, CTT_DESC01 } = item.row.original

            return <>
                    <CelBreak>
                        <strong>{FORNECE}</strong> - {A2_NOME.trim()}
                    </CelBreak>
                    <CelBreak>
                        <strong>CC: {C7_CC.trim()}</strong> - {CTT_DESC01.trim()}
                    </CelBreak>                    
                </>
        } },
        { Header: 'Quantidade',     accessor: 'C7_QUANT' },
        { Header: 'Preço',          accessor: 'C7_PRECO', Cell: handlePrecoUnitario },
        { Header: 'Valor Total',    accessor: 'C7_TOTAL', Cell: handleValorTotal }
    ];
    const Produto = dataCompras[0].B1_COD.trim() + ' - ' + dataCompras[0].B1_DESC.trim()
    const Titulo = (
        <>
            <p>Histórico das Ultimas Compras </p>
            <p>Produto: {Produto}</p>
        </> );

    const Mensagem = (
        <ResponsiveDataTable
            columns={columns}
            data={dataCompras} // Carregar dados conforme necessário
            buttons={[]}
            isIgnorar={true}
        />
    );

    const buttonsRender = [
        { variant: 'primary', action: FechaBox, label: 'Fechar' }
    ];

    DisparaBootBox(Titulo, Mensagem, buttonsRender, 0, FechaBox, 'xl', false);
};

export default UltimasCompras;